import { useQuery } from '@tanstack/react-query';
import { fetchCategories } from '@/api/client';
import type { LanguageCode } from '@/types';

export function useCategories(lang: LanguageCode) {
  return useQuery({
    queryKey: ['categories', lang],
    queryFn: () => fetchCategories(lang),
  });
}
